import React from 'react';

import { Button, Group, Stack, Text } from '@mantine/core';
import useDeleteExpectation from 'hooks/reports/utilization/package-utilization/useDeleteExpectation';
import type { PackageUtilizationExpectationListItem } from 'types';
import notificationHandler from 'utils/notifications';

import { useModal } from '../../Context/ModalContext';

type DeleteExpectationFormProps = {
  packageExpectation: PackageUtilizationExpectationListItem;
};

const DeleteExpectationForm = ({ packageExpectation }: DeleteExpectationFormProps): JSX.Element => {
  const { openModal } = useModal();
  const { mutate: deleteExpectation, isLoading } = useDeleteExpectation();
  const { successNotification, errorNotification } = notificationHandler();

  const handleDelete = (): void => {
    deleteExpectation(packageExpectation.packageUtilizationExpectationId, {
      onSuccess: () => {
        openModal('list');
        successNotification(
          'The package has been deleted from the report',
          `'${packageExpectation.package.name}' has been deleted from the report.`,
        );
      },
      onError: error => {
        errorNotification(
          'The package could not be deleted from the report.',
          error.response?.data.message ?? '',
        );
      },
    });
  };

  return (
    <Stack align='center'>
      <Text weight='bold' size='lg' ta='center'>
        Are you sure you want to delete this package from the report?
      </Text>
      <Text my='5rem'>{packageExpectation.package.name}</Text>
      <Group spacing='4rem'>
        <Button onClick={() => openModal('list')} disabled={isLoading}>
          No, Go Back
        </Button>
        <Button color='red' loading={isLoading} onClick={handleDelete}>
          Yes, Delete
        </Button>
      </Group>
    </Stack>
  );
};

export default DeleteExpectationForm;
